import DropDown from 'components/form/dropDown';
import { OutlineButton } from 'components/form/buttons/outLineButton';

import * as S from './styles';

/**
 * Export, switched off — and saying so.
 *
 * The endpoint does not exist on the server, so the control cannot work. Two
 * things were wrong with how that was expressed:
 *
 * **It gave no reason.** A disabled dropdown and a disabled button, with
 * nothing to say why, read as a screen that is broken or as a permission the
 * reader does not have. The design's `.help` line is the whole fix: say it is
 * not available yet and that the reason is the server.
 *
 * **It was a copy of the login form.** The card was a `<Formik>` wired to
 * `ValidationLogin` and `onSubmit` calling `logInRequestAction` — the sign-in
 * action, on the statistics screen. Both controls were disabled so it could
 * not fire, but a form whose submit handler logs you in is not scaffolding
 * anyone should leave lying next to an Export button. It is gone; nothing here
 * submits.
 *
 * The control is deliberately still drawn rather than hidden. It is a feature
 * this screen is supposed to have, and hiding it would leave no trace that it
 * is coming.
 */
export default function CafeteriaStatisticsSidebarExportDataForm() {
  return (
    <S.Content>
      <DropDown label="Scope" list={[]} disabled placeholder="All users" onChange={() => {}} />

      <S.Action>
        <OutlineButton disabled style={{ width: '100%' }}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round">
            <path d="M12 3v12M8 11l4 4 4-4M4 19h16" />
          </svg>
          Export
        </OutlineButton>
      </S.Action>

      <S.Help>Export is not available yet — the endpoint is disabled on the server.</S.Help>
    </S.Content>
  );
}
